let fromPath = '' // 存来源路由，为在充值页面使用
export default defineComponent({
  beforeRouteEnter(to, from) {
    fromPath = from.path
  },
  setup() {
    const {
      imageUrl,
      goBack,
      userInfo,
      payIndex,
      selectPay,
      dropValue,
      dropText,
      myObj,
      moneyIndex,
      countryIndex,
      country,
      changeMoneyIndex,
      isFirstCharge,
      rechargeClick,
      countryPicker,
      onConfirmCountry,
      handleShowPicker,
      rechargeClickLoading,
      rechargePopupConfig,
      openPopup,
      purseInfo
    } = useRecharge(fromPath)

    return {
      imageUrl,
      goBack,
      userInfo,
      payIndex,
      selectPay,
      dropValue,
      dropText,
      ...toRefs(myObj),
      moneyIndex,
      countryIndex,
      country,
      changeMoneyIndex,
      isFirstCharge,
      rechargeClick,
      countryPicker,
      onConfirmCountry,
      handleShowPicker,
      rechargeClickLoading,
      rechargePopupConfig,
      openPopup,
      purseInfo
    }
  }
})
